module.exports = __webpack_public_path__ + "c7b18755f4970facb37060590f99eff4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/HR.svg
// module id = 1EJd
// module chunks = 0